<style></style>

<template>
    <div class="bar_wrapper">
        <div :style="{width: scale(percentage)+'%'}" 
            class="bar" 
            :class="'bg-'+color"
            :title="percentage+'%'"
        >
            <div :class="modName+'_graph_round marker'"></div>
        </div>
        <div class="assessment_type">
            <div class="y_label text-primary"><span>{{ date }}</span></div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import objectValues from '../../helpers/object_values.js'

    export default {
        components: {},
        props: {
            assessments: {
                required: true,
                type: Array
            },
            module: {
                required: true,
                type: Object
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }
        },
        data() {
            return {}
        },
        computed: {
            percentage: function () {
                if (this.latestFinished && this.latestFinished.score_data){
                    const ratio = this.latestFinished.score_data.total_points/this.latestFinished.score_data.possible_points
                    return Math.round(ratio * 100)
                }
                return 0
            },
            date: function () {
                if (this.latestFinished) {
                    return moment(this.latestFinished.finalized_at).format('MM/DD/YY')
                }
                return ''
            },
            color: function () {
                return this.module.color
            },
            modName: function () {
                switch (this.module.slug) {
                    case 'child-nutrition':
                        return 'nutrition'
                    case 'breastfeeding-and-infant-feeding':
                        return 'infant'
                    case 'infant-and-child-physical-activity':
                        return 'physical'
                    case 'outdoor-play-and-learning':
                        return 'outdoor'
                    case 'farm-to-e-c-e':
                        return 'farm'
                    case 'oral-health':
                        return 'oral'
                    case 'screen-time':
                        return 'screen'
                    case 'social-emotional':
                        return 'social'
                    default:
                        break;
                }
            },
            title: function () {
                return this.module.name
            },
            finishedAssessments: function () {
                return this.assessments.filter(ass => ass.finalized_at !== null);
            },
            latestFinished: function () {
                return this.finishedAssessments.slice(-1)[0]
            },
            previousFinished: function () {
                return this.finishedAssessments.slice(-2, -1)[0];
            }
        },
        methods: {
            scale(value) {
                const points = objectValues(this.surveyCutoffs).reverse().map(val => val*100);
                let a  = (33/points[1]);
                let b = 0;
                if (value < points[1]) {
                } else if ( value < points[2]) {
                    a = 33/(points[2]-points[1]);
                    b = 66 - a*points[2];
                } else {
                    a = 33/(100-points[2]);
                    b = 100 - a*100;
                }
                return (value*a + b)
            }

        }    
}
</script>